<template>
  <div
    class="animated-play-btn-wrapper"
    v-bind="config.attrs"
  >
     <config-style-injector
      v-if="config.css"
      :config="config"
      root-selector=".animated-play-btn-wrapper"
    />

    <div v-if="config.css" class="animated-play-btn">
      <div class="play-wrapper">
        <div class="pulse-ring ring-1"></div>
        <div class="pulse-ring ring-2"></div>

        <div class="main-circle">
          <svg class="play-svg" viewBox="0 0 44 44">
            <circle
              cx="22"
              cy="22"
              r="21"
              fill="currentColor"
              stroke="white"
              stroke-width="2"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M31.6936 22.509L16.9706 30.9103C16.5428 31.1557 16 30.8684 16 30.4013V13.5987C16 13.1316 16.5428 12.8443 16.9706 13.0897L31.6936 21.491C32.1021 21.7245 32.1021 22.2755 31.6936 22.509Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
    </div>

    <!-- Fallback -->
    <img
      v-else
      src="/images/play_button.svg"
      alt="Play Button"
      class="default-play-btn"
    />
  </div>
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";

export default {
  name: "AnimatedPlayButton",
  mixins: [featureMixin],
  components: { ConfigStyleInjector },

  data() {
    return {
      featurePath: "playVideoButton"
    };
  }
};
</script>

<style scoped>
.default-play-btn {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
